import { Toastr } from 'components/global/Toastr'
import { Action } from 'types/redux'
import { handleResponseErr } from 'utils/apiHelperUtils'
import { MentionData } from '@draft-js-plugins/mention'
import * as actions from './actions'
import { convertEmployeesToMentions } from './helper'
import { Employee } from './types'

type InitialStateType = {
  employees: Employee[]
  mentionList: MentionData[]
  fetching: boolean
}

const initialState: InitialStateType = {
  employees: [],
  mentionList: [],
  fetching: false,
}

export default function reducer(state = initialState, action: Action): InitialStateType {
  switch (action.type) {
    case actions.GET_MENTION_LIST_PENDING: {
      return {
        ...state,
        fetching: true,
      }
    }

    case actions.GET_MENTION_LIST_FULFILLED: {
      const employees = action?.payload?.data?.data
      const mentionList = convertEmployeesToMentions(employees)

      return {
        ...state,
        employees,
        mentionList,
        fetching: false,
      }
    }

    case actions.GET_MENTION_LIST_REJECTED: {
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        fetching: false,
      }
    }

    default:
      return state
  }
}
